import { StringFilterState } from '../services/filter/string-filter'

export const userEmailSuffix = '@ameren.com'

export const formatUser = (
  userId: string | null | undefined,
  defaultValue = '',
): string => {
  if (userId?.endsWith(userEmailSuffix)) {
    return userId.slice(0, userId.length - userEmailSuffix.length)
  } else {
    return userId ?? defaultValue
  }
}

export const getUserFilterConfig = (
  fieldGroup: string,
  fieldName: string,
  header: string,
): StringFilterState['config'] => ({
  allowMultiple: true,
  meta: { fieldGroup, fieldName, fieldDisplay: header },
  toFilterValue: paramValue => formatUser(paramValue),
  toParamValue: filterValue =>
    filterValue.includes('@') ? filterValue : `${filterValue + userEmailSuffix}`,
})
